import { Layout, Typography, Space, Avatar, Dropdown, Button } from 'antd'
import { UserOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { logout as logoutAction } from '../components/auth/actions'
import axios from 'axios'

const { Header } = Layout
const { Text } = Typography

interface IUserName {
  user: string
}

const HeaderLayout: React.FC = () => {
  const [user, setUser] = useState('')
  const dispatch = useDispatch()

  const logout = useCallback(async () => {
    logoutAction()(dispatch)
  }, [dispatch])

  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const { data: { user } } = await axios.get<IUserName>('/api/users/me')
        setUser(user)
      } catch (error) {
        // Fallback for development
        setUser('Developer')
      }
    }

    fetchUserName()
  }, [])

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Profile',
      disabled: true
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'Settings',
      disabled: true
    },
    {
      type: 'divider'
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: logout,
      danger: true
    }
  ]

  return (
    <Header 
      className="header-container"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '20px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        height: 'auto',
        minHeight: '64px'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Text 
          style={{ 
            color: 'white', 
            fontSize: '16px', 
            fontWeight: '500',
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
          }}
        >
          {/* Dashboard */}
        </Text>
      </div>
      
      <Space align="center">
        <Dropdown
          menu={{ items: userMenuItems }}
          placement="bottomRight"
          arrow
        >
          <Button
            type="text"
            style={{
              color: 'white',
              border: 'none',
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '8px',
              padding: '4px 12px',
              height: 'auto',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'
            }}
          >
            <Avatar 
              size="small" 
              icon={<UserOutlined />}
              style={{ 
                background: 'rgba(255, 255, 255, 0.2)',
                color: 'white'
              }}
            />
            <Text style={{ color: 'white', fontWeight: '500' }}>
              {user || 'User'}
            </Text>
          </Button>
        </Dropdown>
      </Space>
    </Header>
  )
}

export default HeaderLayout
